import React from 'react';
import { BaseIcon } from './BaseIcon';

export const ExploreIcon: React.FC = () => {
  return (
    <BaseIcon
      title="Explore"
      paths={[
        {
          d: 'M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z',
          strokeLinecap: undefined,
          strokeLinejoin: undefined,
        },
        {
          d: 'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
          strokeLinecap: undefined,
          strokeLinejoin: undefined,
        },
      ]}
    />
  );
};

export default ExploreIcon;
